/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_ShoppingInputs */

const en_nav_shopping = /** @type {(inputs: Nav_ShoppingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shopping`)
};

const de_nav_shopping = /** @type {(inputs: Nav_ShoppingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einkauf`)
};

/**
* | output |
* | --- |
* | "Shopping" |
*
* @param {Nav_ShoppingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const nav_shopping = /** @type {((inputs?: Nav_ShoppingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_ShoppingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_nav_shopping(inputs)
	return en_nav_shopping(inputs)
});